export const injectToken = (example, token) =>
  token ? example && example.replace(/<AUTH>/g, token) : example;
